export default class PassResetRequest {
  email = "";

  setEmail = (input: string) => {
    this.email = input.toLowerCase().trim();
  }
}